import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const useDashboard = () => {
  const getRecentAnnouncements = useCallback(async (val, cellId, userId) => {
    try {
      const values = { departmentId: val, cellId: cellId, userId: userId };
      return await ajax.post(`dashboard/get-recent-announcements`, values);
    } catch (error) {
      return error;
    }
  });

  const getRecentLearningOpportunities = useCallback(async (val) => {
    try {
      return await ajax.post(`dashboard/get-recent-learning-opportunities`, val);
    } catch (error) {
      return error;
    }
  });

  const getRecentGlobalGivingCauses = useCallback(async (val) => {
    try {
      return await ajax.post(`dashboard/get-recent-global-giving-causes`, val);
    } catch (error) {
      return error;
    }
  });

  const getRecentMyCellGlobalGivingCauses = useCallback(async (val) => {
    try {
      const values = { cellId: val };
      return await ajax.post(`dashboard/get-my-cells-recent-global-giving-causes`, values);
    } catch (error) {
      return error;
    }
  });

  const getCompanyQuarterlyGoal = useCallback(async (values) => {
    try {
      return await ajax.post(`dashboard/get-company-quarterly-goal`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyQuarterlyGoal = useCallback(async (values) => {
    try {
      return await ajax.post(`dashboard/get-my-professional-quarterly-goal`, values);
    } catch (error) {
      return error;
    }
  });

  const getCellQuarterlyGoal = useCallback(async (values) => {
    try {
      return await ajax.post(`dashboard/get-cell-quarterly-goal`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyProfessionalQuarterlyGoal = useCallback(async (val) => {
    try {
      const values = { goalId: val };
      return await ajax.post(`dashboard/get-my-professional-quarterly-goal`, values);
    } catch (error) {
      return error;
    }
  });

  const getPerformanceReviewSumReport = useCallback(async (val) => {
    try {
      const values = { goalId: val };
      return await ajax.post(`dashboard/performance-review-sum-report`, values);
    } catch (error) {
      return error;
    }
  });

  const getTotalFileList = useCallback(async (val) => {
    try {
      const values = { goalId: val };
      return await ajax.post(`logiware/get-total-files`, values);
    } catch (error) {
      return error;
    }
  });

  const getLogiwareTotalFileList = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-logiware-total-files`, val);
    } catch (error) {
      return error;
    }
  });

  const getVectorGlobalHealthReport = useCallback(
    async (val, countryId, vectorId, loggedInUsercellId) => {
      try {
        const values = {
          cellId: val,
          countryId: countryId,
          vectorId: vectorId,
          loggedInUsercellId: loggedInUsercellId,
        };
        return await ajax.post(`dashboard/get-Vector-global-health-report`, values);
      } catch (error) {
        return error;
      }
    },
  );

  const getVectorGlobalHealthQuestionReport = useCallback(async (val, countryId, qid, vectorId) => {
    try {
      const values = { cellId: val, countryId: countryId, questionId: qid, vectorId: vectorId };
      return await ajax.post(`dashboard/get-Vector-global-health-question-report`, values);
    } catch (error) {
      return error;
    }
  });

  const getCountry = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-filter-country-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCountryDashboard = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-filter-country-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCellData = useCallback(async (countryId) => {
    try {
      const val = { countryId: countryId };
      let result = await ajax.post(`user/get-filter-cell-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getTotalFileListFromLogiware = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-files-list`, val);
    } catch (error) {
      return error;
    }
  });

  const getTotalProfitsFromLogiware = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-profit-list`, val);
    } catch (error) {
      return error;
    }
  });

  const getFileManagementMyCellTable = useCallback(async (val) => {
    try {
      const values = { cellValue: val?.cellValue, countryTitle: val?.countryTitle };
      //const values = {cellValue: 'VECTORCHILE', countryTitle: 'CL',};
      return await ajax.post(`logiware/get-file-management-my-cell-table`, values);
    } catch (error) {
      return error;
    }
  });
  const getMyLogiwareDetails = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName, countryTitle: val?.countryTitle };
      //const values = { //userName: 'roxana' };
      return await ajax.post(`logiware/get-my-logiware-details`, values);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileWithDate = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-average-gross-profit`, values);
    } catch (error) {
      return error;
    }
  });

  const getCompanyPieDataWithDate = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-company-pie-chart-data`, values);
    } catch (error) {
      return error;
    }
  });
  const getCompanyPieChartChangeInData = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-company-pie-chart-change-in-data`, values);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileYTD = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-average-gross-profit-year-to-date`, val);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileLastYear = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-average-gross-profit-last-year`, val);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileLastYearToDate = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-average-gross-profit-last-year-to-date`, val);
    } catch (error) {
      return error;
    }
  });

  const getCompanyFilesYearToDate = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-company-files-year-to-date`, val);
    } catch (error) {
      return error;
    }
  });

  // const getCompanyFilesLastYear = useCallback(async (val) => {
  //   try {
  //     return await ajax.post(`logiware/get-company-files-last-year`, val);
  //   } catch (error) {
  //     return error;
  //   }
  // });

  const getCompanyFilesLastYear = useCallback(async (val) => {
    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        resolve([]);
      }, 30000); // 30 seconds
    });

    try {
      const response = await Promise.race([
        ajax.post(`logiware/get-company-files-last-year`, val),
        timeout,
      ]);

      return response;
    } catch (error) {
      return error;
    }
  });

  const getCompanyFilesLastYearToDate = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-company-files-last-year-to-date`, val);
    } catch (error) {
      return error;
    }
  });

  const getCountryPieChartData = useCallback(async (val) => {
    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        resolve([]);
      }, 30000); // 30 seconds
    });

    try {
      const response = await Promise.race([
        ajax.post(`logiware/get-country-pie-chart-data`, val),
        timeout,
      ]);

      return response;
    } catch (error) {
      return error;
    }
  });

  const getCountryPieChartChangeInData = useCallback(async (val) => {
    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        resolve([]);
      }, 30000); // 30 seconds
    });

    try {
      const response = await Promise.race([
        ajax.post(`logiware/get-country-pie-chart-change-in-data`, val),
        timeout,
      ]);

      return response;
    } catch (error) {
      return error;
    }
  });

  const getHistoricRevenue = useCallback(async (val) => {
    try {
      const values = {
        startYear: val?.startYear,
        endYear: val?.endYear,
        cellValue: val?.cellValue,
        cellId: val?.cellId,
      };
      return await ajax.post(`logiware/get-historic-revenue`, values);
    } catch (error) {
      return error;
    }
  });

  const getHistoricGross = useCallback(async (val) => {
    try {
      const values = {
        startYear: val?.startYear,
        endYear: val?.endYear,
        cellValue: val?.cellValue,
        cellId: val?.cellId,
      };
      return await ajax.post(`logiware/get-historic-gross`, values);
    } catch (error) {
      return error;
    }
  });

  const getOptimalInvoiceData = useCallback(async (val) => {
    try {
      const values = { year: val?.year, dateRange: val?.dateRange, userName: val?.userName };
      return await ajax.post(`logiware/get-optimal-invoice-delta`, values);
    } catch (error) {
      return error;
    }
  });

  const getOptimalInvoiceRanking = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName };
      return await ajax.post(`logiware/get-optimal-invoice-delta-ranking`, values);
    } catch (error) {
      return error;
    }
  });

  const getActiveAdminDelta = useCallback(async (val) => {
    try {
      const values = { year: val?.year, dateRange: val?.dateRange, userName: val?.userName };
      return await ajax.post(`logiware/get-active-admin-delta`, values);
    } catch (error) {
      return error;
    }
  });

  const getActiveAdminDeltaRanking = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName };
      return await ajax.post(`logiware/get-active-admin-delta-ranking`, values);
    } catch (error) {
      return error;
    }
  });

  const getAdminClosedDelta = useCallback(async (val) => {
    try {
      const values = { year: val?.year, dateRange: val?.dateRange, userName: val?.userName };
      return await ajax.post(`logiware/get-admin-closed-delta`, values);
    } catch (error) {
      return error;
    }
  });

  const getAdminClosedDeltaRanking = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName };
      return await ajax.post(`logiware/get-admin-closed-delta-ranking`, values);
    } catch (error) {
      return error;
    }
  });

  const getTotalOperations = useCallback(async (val) => {
    try {
      const values = { cellValue: val?.cellValue, countryTitle: val?.countryTitle };
      //const values = {cellValue: 'SELL CELL A', countryTitle: 'PE',};
      return await ajax.post(`logiware/get-total-operations`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCellPerformance = useCallback(async (val) => {
    try {
      const values = { cellValue: val?.cellValue, countryTitle: val?.countryTitle };
      //const values = {cellValue: 'SELL CELL A', countryTitle: 'PE',};
      return await ajax.post(`logiware/get-my-cell-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyInvoicingPerformance = useCallback(async (val) => {
    try {
      const values = {
        userName: val?.userName,
        userId: val?.userId,
        countryTitle: val?.countryTitle,
      };
      ///const values = {userName: 'roxana', userId: '681e783e-c4fc-467a-9e7e-b98afa38a8d8',};
      return await ajax.post(`logiware/get-my-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCellInvoicingPerformance = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
        cellId: val?.cellId,
      };
      //const values = {cellValue: 'SELL CELL D', countryTitle: 'MX',};
      return await ajax.post(`logiware/get-my-cell-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCompanyInvoicingPerformance = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
        countryId: val?.countryId,
      };
      //const values = {cellValue: 'SELL CELL D', countryTitle: 'MX',};
      return await ajax.post(`logiware/get-my-company-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getUserInvoicingDetails = useCallback(async (val) => {
    try {
      const values = {
        userName: val?.userName,
        userId: val?.userId,
        countryTitle: val?.countryTitle,
      };
      ///const values = {userName: 'roxana', userId: '681e783e-c4fc-467a-9e7e-b98afa38a8d8',};
      return await ajax.post(`logiware/get-user-invoicing-performance`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCellPerformanceFiles = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName, countryTitle: val?.countryTitle };
      ///const values = {userName: 'null', userId: '681e783e-c4fc-467a-9e7e-b98afa38a8d8',};
      return await ajax.post(`logiware/get-performance-files`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCellPerformanceProfits = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName, countryTitle: val?.countryTitle };
      ///const values = {userName: 'roxana', userId: '681e783e-c4fc-467a-9e7e-b98afa38a8d8',};
      return await ajax.post(`logiware/get-performance-profits`, values);
    } catch (error) {
      return error;
    }
  });

  const getCellWorkLoadNunbers = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
      };
      //const values = { cellValue: 'SELL CELL D', countryTitle: 'UNITED STATES' };
      return await ajax.post(`logiware/get-cell-workload-numbers`, values);
    } catch (error) {
      return error;
    }
  });

  const getCellWorkLoadList = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
        cellLists: val?.cellLists || [],
      };
      //const values = { cellValue: 'SELL CELL D', countryTitle: 'UNITED STATES' };
      return await ajax.post(`logiware/get-cell-workload-list`, values);
    } catch (error) {
      return error;
    }
  });

  const getCellHistoricTable = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryTitle: val?.countryTitle,
        startYear: val?.startYear,
        endYear: val?.endYear,
      };
      // const values = { cellValue: 'SELL CELL D', countryTitle: 'UNITED STATES' };
      return await ajax.post(`logiware/get-cell-historic-table`, values);
    } catch (error) {
      return error;
    }
  });

  const getClientComplexityScoreTable = useCallback(async (val) => {
    try {
      const values = {
        cellValue: val?.cellValue,
        countryValue: val?.countryValue,
      };
      // const values = { cellValue: 'SELL CELL D', countryTitle: 'UNITED STATES' };
      return await ajax.post(`logiware/get-client-complexity-score-table`, values);
    } catch (error) {
      return error;
    }
  });

  const getUserHistoricRevenue = useCallback(async (val) => {
    try {
      const values = { year: val?.year, dateRange: val?.dateRange, userName: val?.userName };
      return await ajax.post(`logiware/get-user-historic-revenue`, values);
    } catch (error) {
      return error;
    }
  });

  const getUserHistoricGross = useCallback(async (val) => {
    try {
      const values = { year: val?.year, dateRange: val?.dateRange, userName: val?.userName };
      return await ajax.post(`logiware/get-user-historic-gross`, values);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileForUser = useCallback(async (val) => {
    try {
      const values = { year: val?.year, dateRange: val?.dateRange, userName: val?.userName };
      return await ajax.post(`logiware/get-average-gross-profit-user`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyPersonalPerformancePerChangeStatus = useCallback(async (val) => {
    try {
      const values = { userName: val?.userName, countryTitle: val?.countryTitle };
      return await ajax.post(`logiware/get-my-logiware-per-change-details`, values);
    } catch (error) {
      return error;
    }
  });

  const getTotalFileListPerChangeFromLogiware = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-company-file-management-per-change-details`, val);
    } catch (error) {
      return error;
    }
  });

  const getFileManagementMyCellTablePerChangeStatus = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-cell-file-management-per-change-details`, val);
    } catch (error) {
      return error;
    }
  });

  const getAverageGrossProfitPerFileCompany = useCallback(async (val) => {
    try {
      const values = { startYear: val?.startYear, endYear: val?.endYear };
      return await ajax.post(`logiware/get-average-gross-profit-company`, values);
    } catch (error) {
      return error;
    }
  });

  const getCurrentWorkloadGraph = useCallback(async (val) => {
    try {
      return await ajax.post(`logiware/get-current-workload-graph`, val);
    } catch (error) {
      return error;
    }
  });

  return {
    getRecentAnnouncements,
    getRecentLearningOpportunities,
    getRecentGlobalGivingCauses,
    getRecentMyCellGlobalGivingCauses,
    getCompanyQuarterlyGoal,
    getCellQuarterlyGoal,
    getMyQuarterlyGoal,
    getMyProfessionalQuarterlyGoal,
    getPerformanceReviewSumReport,
    getTotalFileList,
    getLogiwareTotalFileList,
    getVectorGlobalHealthReport,
    getVectorGlobalHealthQuestionReport,
    getCountry,
    getCellData,
    getTotalFileListFromLogiware,
    getTotalProfitsFromLogiware,
    getFileManagementMyCellTable,
    getMyLogiwareDetails,
    getTotalOperations,
    getMyCellPerformance,
    getMyInvoicingPerformance,
    getMyCellInvoicingPerformance,
    getMyCompanyInvoicingPerformance,
    getUserInvoicingDetails,
    getMyCellPerformanceFiles,
    getMyCellPerformanceProfits,
    getOptimalInvoiceData,
    getAdminClosedDelta,
    getActiveAdminDelta,
    getOptimalInvoiceRanking,
    getAdminClosedDeltaRanking,
    getActiveAdminDeltaRanking,
    getAverageGrossProfitPerFileYTD,
    getAverageGrossProfitPerFileLastYear,
    getAverageGrossProfitPerFileLastYearToDate,
    getCompanyFilesLastYearToDate,
    getCompanyFilesLastYear,
    getCompanyFilesYearToDate,
    getAverageGrossProfitPerFileWithDate,
    getCompanyPieDataWithDate,
    getCountryPieChartData,
    getHistoricRevenue,
    getHistoricGross,
    getCellWorkLoadNunbers,
    getCellWorkLoadList,
    getCellHistoricTable,
    getClientComplexityScoreTable,
    getUserHistoricGross,
    getUserHistoricRevenue,
    getAverageGrossProfitPerFileForUser,
    getCountryDashboard,
    getMyPersonalPerformancePerChangeStatus,
    getTotalFileListPerChangeFromLogiware,
    getFileManagementMyCellTablePerChangeStatus,
    getCountryPieChartChangeInData,
    getCompanyPieChartChangeInData,
    getAverageGrossProfitPerFileCompany,
    getCurrentWorkloadGraph,
  };
};
export default useDashboard;
